import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OscNetworkStatusService {
  public isOnline: boolean;
  public isOnlineSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  public setOnlineStatus(): void {
    this.isOnline = true;
    this.isOnlineSubject.next(true);
  }

  public setOfflineStatus(): void {
    this.isOnline = false;
    this.isOnlineSubject.next(false);
  }
}
